<template>
  <div>
    <div class="d-flex align-center">
      <h2>{{ $t('guidance.formMastSettings') }}</h2>
    </div>

    <!-- table -->
    <div class="mt-6">
      <v-data-table
        :headers="headers"
        :items="mastResponse ? mastResponse.data : []"
        :loading="loading"
        hide-default-footer
        :items-per-page="-1"
      >
        <!-- type -->
        <template v-slot:[`item.type`]="{ item }">
          {{ getPlanText(item.type) }}
        </template>

        <!-- createdAt -->
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>

        <template v-slot:[`item.duplicate`]="{ item }">
          <v-btn
            @click="duplicateForm(item.id)"
            :disabled="loading"
            color="primary"
            variant="outlined"
            small
          >
            {{ $t('guidance.duplicateToFormSettings') }}
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script lang="ts">
import ApiGuidance from "@/api/ApiGuidance";
import { GuidancePlanTypeItems } from "@/constants/guidance";
import LocalDataService from "@/service/LocalDataService";
import { NurseryGuidancePlanFormMastListResponse } from "chaild-api/lib";
import dayjs from "dayjs";
import { defineComponent } from "vue";
export default defineComponent({
  name: "GuidancePlanFormMastList",

  async mounted() {
    await this.listMast();
  },

  data() {
    return {
      loading: false,
      headers: [
        { title: this.$t('guidance.templateName'), key: "name" },
        { title: this.$t('guidance.type'), key: "type" },
        { title: this.$t('guidance.createdAt'), key: "createdAt" },
        { title: this.$t('guidance.duplicate'), key: "duplicate" },
      ],
      searchFilters: {
        limit: 10000,
        skip: 0,
      },
      planItems: GuidancePlanTypeItems,
      mastResponse: null as null | NurseryGuidancePlanFormMastListResponse,
    };
  },

  methods: {
    async listMast() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiGuidance.listPlanFormMast({
          nurseryId,
          ...this.searchFilters,
        }).catch(() => (this.loading = false));
        if (response) {
          this.mastResponse = response;
        }
      }
      this.loading = false;
    },
    async duplicateForm(formMastId: string) {
      const answer = confirm(this.$t('guidance.duplicateConfirm') as string);
      const nurseryId = LocalDataService.getNurseryId();
      if (answer && nurseryId) {
        this.loading = true;
        const response = await ApiGuidance.duplicatePlanFormMast({
          nurseryId,
          formMastId,
        }).catch(() => (this.loading = false));
        if (response) {
          alert(this.$t('guidance.duplicateSuccess') as string);
          await this.listMast();
        }
      }
      this.loading = false;
    },
    getPlanText(value: string): string {
      const item = this.planItems.find((p) => p.value == value);
      return item?.text || "";
    },
    formatDate(value: string): string {
      if (!value) {
        return "";
      }
      return dayjs(value).format("DD/MM/YYYY");
    },
  },
});
</script>
